/* eslint-disable */
import React, { useEffect, useState } from "react";
import { eachDayOfInterval, parseISO, format, addDays } from "date-fns";
import { ptBR } from "date-fns/locale";
import API_USERS from "../../services/users";

import * as Styles from "./styles";
import ProfileCard from "./components/ProfileCard";
import Table from "./components/Table";
import { UserPlatform } from "../../interfaces";
import SkeletonLoading from "./components/SkeletonLoading";

const logUser: React.FC = () => {
  const [data, setData] = useState<any>(null);
  const [logsData, setLogsData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    getUserData();
  }, []);

  const converterData = (data: string) => {
    var day: any = data.substring(0, 2);
    var month: any = data.substring(3, 5);
    var year: any = data.substring(6, 10);
    var convertedDate: string = year + "-" + month + "-" + day;
    return format(parseISO(convertedDate), "EEEE", { locale: ptBR });
  };

  const getUserData = async () => {
    var storedArray = await localStorage.getItem("@userlog");
    if (storedArray) {
      setData(JSON.parse(storedArray));
    }
  };

  useEffect(() => {
    if (data) {
      requestLogs();
    }
  }, [data]);

  const requestLogs = async () => {
    setLoading(true);
    try {
      const response = await API_USERS.GetUserLog(data?.id);
      const { data: logs } = response?.data;
      const dataArray: any = [];

      logs.forEach((element: any) => {
        dataArray.push({
          id: 3,
          nome_agenda: element?.nomeAgenda,
          local: element?.nomeLocal,
          dia_semana: converterData(element.dataTurno),
          turno: element?.turno,
          acao: element?.acaoRealizada,
          tipoCancelamentoPreReserva: element.tipoCancelamentoPreReserva,
          hora_acao: element?.dataHoraAcao,
        });
      });
      setLogsData(dataArray);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Styles.Container>
      {data !== null && <ProfileCard data={data} />}
      <Styles.SpaceY space={32} />
      <Styles.Card>
        {loading ? (
          <SkeletonLoading />
        ) : logsData.length > 0 ? (
          <Table data={logsData} />
        ) : (
          <Styles.EmptyContainer>
            <Styles.EmptyMessage>
              Este usuário não possui logs
            </Styles.EmptyMessage>
          </Styles.EmptyContainer>
        )}
      </Styles.Card>
    </Styles.Container>
  );
};

export default logUser;
